import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  paymentScheduleData: {},
  cancelLoanFunction: null,
  paymentScheduleCurrentDate: null,
  refreshPaymentSchedule: null,
  loanId: null,
};

export const paymentScheduleDataSlice = createSlice({
  name: 'paymentScheduleData',
  initialState,
  reducers: {
    setPaymentScheduleData: (state, action) => {
      state.paymentScheduleData = action.payload;
    },
    setCancelLoanFunction: (state, action) => {
      state.cancelLoanFunction = action.payload;
    },
    setPaymentScheduleCurrentDate: (state, action) => {
      state.paymentScheduleCurrentDate = action.payload;
    },
    setRefreshPaymentSchedule: (state, action) => {
      state.refreshPaymentSchedule = action.payload;
    },
    setLoanId: (state, action) => {
      state.loanId = action.payload;
    },
  },
});

export const { setPaymentScheduleData, setCancelLoanFunction, setPaymentScheduleCurrentDate, setRefreshPaymentSchedule, setLoanId } = paymentScheduleDataSlice.actions;
export const selectPaymentScheduleData = (state) => state.paymentScheduleData

export default paymentScheduleDataSlice.reducer;
